
const snackbar = {
    namespaced: true,
    state: {
        msg: '',
        visible: false,
        color: ''
    },
    mutations: {
        SHOW_SNACKBAR: (state, options) => {
            state.visible = true;
            state.msg = options.msg;
            state.color = options.color;
        },
        ClOSE_SNACKBAR: (state) => {
            state.visible = false;
        }
    },
    actions: {
        openMsg(context, options) {
            context.commit('SHOW_SNACKBAR', {
                msg: options.msg,
                color: options.color
            })
            console.log(options);

            if (options.timeout) {
                setTimeout(() => {
                    context.commit('ClOSE_SNACKBAR')
                }, options.timeout)
            }
        }
    }
}

export default snackbar;